import { FC } from 'react'
import { useNavigate } from 'react-router'

import { TO_PARENT_PATH } from '@/modules/urlRouting/paths'

import { usePolicyEditContext } from '../../policyEditController'
import { getModalText } from '../../utils/modalText'
import { PolicyDetailsMap } from '../PolicyDetailsMap'

import { PolicyStatusChip } from './PolicyStatusChip'
import { ThemedBackLink } from './ThemedBackLink'
import { ThemedEditActions } from './ThemedEditActions'
import { ThemedPolicyDetailsLayout } from './ThemedPolicyDetailsLayout'
import { ThemedPolicyForm } from './ThemedPolicyForm'
import { ThemedPolicyNameField } from './ThemedPolicyNameField'

/** The new Mobility theme look of the edit, create and duplicate policy pages. */
export const ThemedPolicyEditView: FC = () => {
  const navigate = useNavigate()
  const controller = usePolicyEditContext()
  const { policy } = controller

  // The same as the old back link: ask first, because the changes are not saved.
  const confirmLeave = () =>
    controller.setModalProps({
      ...getModalText().INFO_CANCEL,
      onCancel: controller.clearModalProps,
      onConfirm: () => {
        controller.clearModalProps()
        navigate(controller.isNew ? TO_PARENT_PATH : `${TO_PARENT_PATH}/${TO_PARENT_PATH}`)
      },
    })

  return (
    <ThemedPolicyDetailsLayout
      disabled={controller.isFetching || controller.isSaving}
      backLink={<ThemedBackLink onClick={confirmLeave} />}
      title={<ThemedPolicyNameField />}
      // The old form shows the status only for a policy that has been saved before.
      status={policy?.policyUUID ? <PolicyStatusChip policy={policy} /> : undefined}
      actions={<ThemedEditActions />}
      map={<PolicyDetailsMap shapeLayerUUID={policy?.shapeLayerUUID || undefined} />}
      details={
        policy && (
          <ThemedPolicyForm
            editable
            editPolicy={controller.editPolicy}
            policy={policy}
            errors={controller.formErrors}
            clearErrors={controller.clearFormErrors}
            setErrors={controller.setFormErrors}
          />
        )
      }
    />
  )
}
